import './TicketDetailNgSliderItem.less';

import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';

import QuestionMarkCircleIcon from 'nike-ui/src/icons/svg/question-mark-circle-icon-sv.svg';
import CheckCircleIcon from 'nike-ui/src/icons/svg/check-circle-icon-sv.svg';
import RvoCircleIcon from 'nike-ui/src/icons/svg/rvo-circle-icon-sv.svg';
import CrossCircleIcon from 'nike-ui/src/icons/svg/cross-circle-icon-sv.svg';
import { formatMoney } from '@/common/client';
import ReturnCircleIcon from 'nike-ui/src/icons/svg/return-circle-icon-sv.svg';
import SavedTicketIcon from '@/icons/SavedTicketIcon';
import { isTicketSaved } from '@/mytickets/utils';

function TicketStatusIcon({ ticketStatus }) {
    switch (ticketStatus) {
        case 'Registered':
            return <QuestionMarkCircleIcon />;
        case 'PaidOut':
        case 'CashinPaidOut':
        case 'Won':
            return <CheckCircleIcon />;
        case 'Lost':
            return <CrossCircleIcon />;
        case 'Cancelled':
            return <RvoCircleIcon />;
        case 'Returned':
        case 'ReturnWon':
        case 'ReturnPaidOut':
            return <ReturnCircleIcon />;
        case 'Saved':
            return <SavedTicketIcon />;
        default:
            return <QuestionMarkCircleIcon />;
    }
}

function TicketDetailNgSliderItem({ ticket, selected, onClick }) {
    const ref = useRef(null);
    const isSavedTicket = isTicketSaved(ticket);
    const ticketStatus = isSavedTicket ? 'Saved' : ticket.displayStatus;
    useEffect(() => {
        if (selected && ref.current) {
            ref.current.scrollIntoView();
            window.scrollTo(0, 0);
        }
    }, [selected]);

    return (
        <div
            ref={ref}
            className={clsx('ticket-detail-slider-item-new', { selected, ticketStatus })}
            data-atid="ticket-detail-slider-item"
            onClick={onClick}
        >
            <div className={clsx('ticket-detail-slider-item-content', ticketStatus)}>
                <div className="item-values">
                    <div className={clsx('ticket-icon', ticketStatus)}>
                        <TicketStatusIcon ticketStatus={ticket.displayStatus} />
                    </div>
                    <div className="item-value-win self-center">{formatMoney(ticket.win, 'EUR', 2)}</div>
                </div>
            </div>
        </div>
    );
}

export default TicketDetailNgSliderItem;
